import * as apis from 'services/item_unit';
import { createBasicStaticModel } from './common';

export default createBasicStaticModel({
  apis,
  namespace: 'itemUnit',
  singleAttr: 'item_unit',
  listAttr: 'item_units',
});



// WEBPACK FOOTER //
// ./src/models/item_unit.js